<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block; max-width: 800px">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>이력</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li>
                        <span>연번</span>
                        <input type="text" v-model="state.data.number" placeholder="연번을 등록해주세요." />
                    </li>

                    <li>
                        <span class="starMark">메모</span>
                        <textarea style="height: 400px" v-model="state.data.memo" placeholder="메모를 등록해주세요."></textarea>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <template v-if="state.mode">
                        <button class="submit_btn" @click="confirm(1)">등록</button>
                    </template>
                    <template v-else>
                        <button class="submit_btn" @click="confirm(2)">저장</button>
                        <button class="submit_btn _gray" @click="confirmRemove">삭제</button>
                    </template>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="state.isShowModal = false"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils, types, apiService, ModalDefault, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            clIdx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                data: {} as types.client.ClientHistoryVOForApi,

                idx: 0 as number,
                clIdx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                gubun: 1 as 1 | 2 | 3, // 1: add, 2: modify, 3: remove
                mode: true as boolean, // true: insert, false: update
            });

            onMounted(() => {
                state.idx = props.idx;
                state.clIdx = props.clIdx;

                if (state.idx > 0) state.mode = false;
                else state.mode = true;

                if (!state.mode) detail();
                else state.data = { idx: 0, createDate: null, memo: "", number: "", writer: "" };

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.idx = props.idx;
                state.clIdx = props.clIdx;

                if (state.idx > 0) state.mode = false;
                else state.mode = true;

                if (!state.mode) detail();
                else state.data = { idx: 0, createDate: null, memo: "", number: "", writer: "" };
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            add();
                            break;
                        case 2:
                            save();
                            break;
                        case 3:
                            remove();
                            break;
                    }
                } else if (param.action === "callback") {
                    emit("callback");
                }
            };

            const detail = async () => {
                const res = await apiService.client.detailForHistory(state.idx);

                if (res.returnCode === 0 && res.data) {
                    state.data = res.data;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const add = async () => {
                const param: types.client.ReqClientHistory = {
                    number: state.data.number,
                    memo: state.data.memo,
                };
                const res = await apiService.client.addForHistory(state.clIdx, param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "등록되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const save = async () => {
                const param: types.client.ReqClientHistory = {
                    number: state.data.number,
                    memo: state.data.memo,
                };
                const res = await apiService.client.modifyForHistory(state.idx, param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "수정 되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                const res = await apiService.client.removeForHistory(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제 되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirm = (gubun: 1 | 2) => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 저장하시겠습니까?";
                state.isShowModal = true;
                state.gubun = gubun;
            };
            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };

            return { state, closeModal, callbackModal, confirm, confirmRemove, CommonUtils };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 110px;
        margin-right: 10px;
        text-align: left;

        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;

        color: #252525;
    }

    textarea {
        width: 100%;
    }
</style>
